var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 2.054c0-.368.299-.667.667-.667h11c.368 0 .667.299.667.667v8.333h.666c.368 0 .667.299.667.667v1.333a2.667 2.667 0 0 1-2.667 2.667H4a2.667 2.667 0 0 1-2.667-2.667V2.054zm11 8.333V2.721H2.667v9.666c0 .53.308.987.755 1.202a.911.911 0 0 0 .911-.91v-2.292h8zm0 3.334H5.41c.164-.311.257-.665.257-1.043v-.957h8v.666c0 .737-.597 1.334-1.334 1.334zm-8-9.334a.667.667 0 0 0 0 1.334h6a.667.667 0 0 0 0-1.334h-6zm0 3a.667.667 0 0 0 0 1.334H8a.667.667 0 1 0 0-1.334H4.333z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.fadcaf246723e0ca157b4f408f4634c6.svg";
export { ForwardRef as ReactComponent };